import * as angular from 'angular';
import {StateProvider} from '@uirouter/angularjs';
import IntuitPartnerPaymentController from "./IntuitPartnerPaymentController";
import MerchantResidualController from "./MerchantResidualController";

class Routes {
    static $inject = ['$stateProvider'];

    constructor($stateProvider: StateProvider) {
        $stateProvider
            .state('import', {
                abstract: true,
                url:'/import'
            })

            .state('import.intuitPartnerPayment', {
                url: '/intuitPartnerPayment',
                template: require('./IntuitPartnerPayment.html'),
                controller: IntuitPartnerPaymentController,
                controllerAs: 'vm',
                data: {title: 'Intuit Partner Payments'}
            })

            .state('import.merchantResidual', {
                url: '/merchantResidual',
                template: require('./MerchantResidual.html'),
                controller: MerchantResidualController,
                controllerAs: 'vm',
                data: {title: 'Merchant Residuals'}
            })



    }
}

export default angular.module('app.import', [])
    .config(Routes)
    .name;
